import { type ComponentProps, lazy, Suspense } from 'react';

import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

const PieChartView = lazy(() => import('./PieChartView'));

type PieChartProps = ComponentProps<typeof PieChartView>;

const PieChart = (props: PieChartProps) => (
  <Suspense fallback={<LoaderSpinner />}>
    <PieChartView {...props} />
  </Suspense>
);

export default PieChart;
